import { render, staticRenderFns } from "./ModalDesignationForm.vue?vue&type=template&id=2e6e3d6c&scoped=true"
import script from "./ModalDesignationForm.vue?vue&type=script&lang=js"
export * from "./ModalDesignationForm.vue?vue&type=script&lang=js"
import style0 from "./ModalDesignationForm.vue?vue&type=style&index=0&id=2e6e3d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e3d6c",
  null
  
)

export default component.exports